import { ReactNode } from 'react';

import { Typography } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

const StyledSocialShare = styled.div`
  &.social-share-container {
    text-align: center;
    max-width: 200px;
    margin: auto;

    .text-container {
      margin: ${({ theme }) => theme.spacing(2, 0, 1)};
    }

    .button-container {
      display: flex;
      justify-content: space-between;
    }
  }
`;

interface SocialShareProps {
  className?: string;
  text?: ReactNode;
  children: ReactNode;
}

export const SocialShare = ({ children, className, text }: SocialShareProps) => {
  return (
    <StyledSocialShare className={clsx('social-share-container', className)}>
      {text && (
        <Typography className="text-container" variant="body1">
          {text}
        </Typography>
      )}
      <div className="button-container">{children}</div>
    </StyledSocialShare>
  );
};
